export const ROUTE_SIGN_UP = "/signup";
export const ROUTE_NOT_FOUND = "/not-found";
export const ROUTE_PASSWORD_SET = "/passwordset";
export const ROUTE_LOGIN = "/login";
export const ROUTE_RESET_PASSWORD = "/resetpassword";
